import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Label from "../../common/primitives/Label";

import styles from './CartLines.scss';

import helpers from "../../common/scss/helpers/_helpers.scss";
import buttons from "../../common/primitives/Button.scss";
import removeImg from './img/remove.png';
import Price, {ConvertToEUR} from "../../common/primitives/Price";
import LoadingRow from "../../common/primitives/LoadingRow";
import TextBox from "../../common/primitives/TextBox";
import Button from "../../common/primitives/Button";
import Tooltip from "../../common/primitives/Tooltip";
import {__t} from '../../common/lang/text-resource';

const CartLineSSL = ({
						 data,
						 taxonomy,
						 removeService,
						 changeServiceTerm,
						 childServices,
						 showAsPage,
						 setSSLDomainName
					 }) => {
	const {
		id,
		serviceName,
		serviceNameOrig,
		serviceTypeName,
		serviceId,
		priceData,
		servicePriceId,
		discountPriceList,
		discountPromo,
		discountTerm,
		isNewService,
		isRenewService,
		canDelete,
		isFree,
		term,
		oldPrice,
		price,
		currency,
		priceOrig,
		priceTopOrig,
		loading,
		cartItemName,
		accountName,
		isSSLWildCard
	} = data;

	const [showInputField, setShowInputField] = useState(serviceNameOrig === cartItemName);
	useEffect(() => {
		setShowInputField(serviceNameOrig === cartItemName);
	}, [cartItemName])

	if (loading) {
		return (
		  <section className={showAsPage ? styles.asPage : ''}>
			  <div
				data-layout={`row gutter-none start ${!showAsPage ? 'margin-bottom--xs padding-bottom--xxs' : ''}`}>
				  <div data-layout='col 12 text-center'>
					  <div className={styles.loadingContainer}>
						  <LoadingRow/>
					  </div>
				  </div>
			  </div>
		  </section>
		)
	}

	return (
	  <section className={showAsPage ? styles.asPage : ''}>
		  <div data-layout={`row gutter-none start ${!showAsPage ? 'margin-bottom--xs padding-bottom--xxs' : ''}`}>
			  <div
				className={styles.removeContainer}
				data-layout={`padding-top--xxs ${!showAsPage ? 'padding-left--xs col 1' : ''}`}>
				  {
					canDelete === true &&
					<button data-layout={!showAsPage ? 'margin-left--xxs' : ''}
							className={`${buttons.buttonImage} ${styles.removeButton}`}
							onClick={() => removeService(id, serviceId, serviceName)}>
						<img src={removeImg} alt={__t("Remove")}/>
					</button>
				  }
			  </div>
			  <div data-layout={`col 11 text-left padding-left--xs ${showAsPage ? '5@md' : ''}`}>
				  <Label
					htmlFor={id}
					text={`${serviceNameOrig}`}
					className={`${helpers.orderServiceName} ${!showAsPage ? styles.asPageServiceName : ''}`}/>
			  </div>
			  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
			  <div data-layout={`col 11 margin-top--xs padding-left--xs ${showAsPage ? '6@md' : ''}`}>
				  {
					  isFree ?
						<table className={styles.selectedPriceContainer}>
							<tbody>
							<tr>
								<td>{term}</td>
								<td className={styles.oldPrice}>
									{
										oldPrice !== price ? oldPrice : null
									}
									{SHVO.showEuroPrices && <>
										<br/>
										{
											oldPrice !== price ? ConvertToEUR(oldPrice) : null
										}
									</>}
								</td>
								<td>
									<Price
									  currency={currency}
									  value={priceOrig}
									  currencyClass={styles.currency}/>
									{SHVO.showEuroPrices && <>
										<br/>
										<Price
										  currency={'EUR'}
										  value={ConvertToEUR(priceOrig)}
										  currencyClass={styles.currency}/>
									</>}
								</td>
								<td data-layout="padding-right--md">&nbsp;</td>
							</tr>
							</tbody>
						</table>

						:


						showAsPage === true ?
						  /*<SelectPrice
							  name={id}
							  newPriceCol="price"
							  valueCol="priceId"
							  labelCol="term"
							  options={priceData}
							  oldPriceCol="oldPrice"
							  currencyCol="currency"
							  selected={servicePriceId}
							  onChange={changeServiceTerm}
							  onMenuOpen={() => {
								  HelperGoogleAnalytics.TrackServicePriceSelectorOpen(taxonomy, isNewService);
								  HelperGoogleAnalytics4.TrackServicePriceSelectorOpen(taxonomy, isNewService);
							  }}/>*/
						  <table className={styles.selectedPriceContainer}>
							  <tbody>
							  <tr>
								  <td>{term}</td>
								  <td className={styles.oldPrice}>
									  {
										  priceTopOrig !== priceOrig ? priceTopOrig : null
									  }
									  {SHVO.showEuroPrices && <>
										  <br/>
										  {
											  priceTopOrig !== priceOrig ? ConvertToEUR(priceTopOrig) : null
										  }
									  </>}
								  </td>
								  <td>
									  <Price
										currency={currency}
										value={priceOrig}
										currencyClass={styles.currency}/>
									  {SHVO.showEuroPrices && <>
										  <br/>
										  <Price
											currency={'EUR'}
											value={ConvertToEUR(priceOrig)}
											currencyClass={styles.currency}/>
									  </>}
								  </td>
								  <td data-layout='padding-right--md'>&nbsp;</td>
							  </tr>
							  </tbody>
						  </table>
						  :
						  <table className={styles.selectedPriceContainer}>
							  <tbody>
							  <tr>
								  <td>{term}</td>
								  <td className={styles.oldPrice}>
									  {
										  priceTopOrig !== priceOrig ? priceTopOrig : null
									  }
									  {SHVO.showEuroPrices && <>
										  <br/>
										  {
											  priceTopOrig !== priceOrig ? ConvertToEUR(priceTopOrig) : null
										  }
									  </>}
								  </td>
								  <td>
									  <Price
										currency={currency}
										value={priceOrig}
										currencyClass={styles.currency}/>
									  {SHVO.showEuroPrices && <>
										  <br/>
										  <Price
											currency={'EUR'}
											value={ConvertToEUR(priceOrig)}
											currencyClass={styles.currency}/>
									  </>}
								  </td>
								  <td data-layout='padding-right--md'>&nbsp;</td>
							  </tr>
							  </tbody>
						  </table>

				  }
			  </div>
		  </div>
		  <div data-layout="row gutter-none start" className={styles.discountsWrapper}>

			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  {/*Редове с отстъпки начало*/}
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  <div className={styles.rightAtTabPage} data-layout={`col 12 ${showAsPage ? '6@md' : ''}`}>
				  {
					  (discountPriceList > 0 && discountPromo < 100) ?
						<div data-layout="row gutter-none middle">
							<div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
							<div
							  data-layout="col 11 margin-top--xs padding-left--xs text-left"
							  className={helpers.orderServiceDiscount}>
								{__t('–-discountPriceList%-допълнителна-партньорска-отс6e0524', {discountPriceList: discountPriceList})}
							</div>
						</div>
						: ''
				  }

				  {
					  (discountPromo > 0) ?
						<div data-layout="row gutter-none middle">
							<div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
							<div
							  data-layout="col 11 margin-top--xs padding-left--xs text-left"
							  className={helpers.orderServiceDiscount}>
								{__t('–:discountPromo% отстъпка от промокод', {discountPromo: discountPromo})}
							</div>
						</div>
						: ''
				  }

				  {
					  (discountTerm > 0 && discountPromo < 100) ?
						<div data-layout="row gutter-none middle">
							<div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
							<div
							  data-layout="col 11 margin-top--xs padding-left--xs text-left"
							  className={helpers.orderServiceDiscount}>
								{isRenewService ? __t('–:discountTerm% промоционална отстъпка', {discountTerm: discountTerm}) : __t('–:discountTerm% отстъпка за нова услуга', {discountTerm: discountTerm})}
							</div>
						</div>
						: ''
				  }
			  </div>
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  {/*Редове с отстъпки край*/}
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			  {
				  showAsPage ? <div className={styles.removeContainer} data-layout="first@md"/> : ''
			  }
			  <div data-layout={`col 12 ${showAsPage ? '5@md first@md' : ''}`}>
				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				  {/*Основен домейн начало*/}
				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				  <div data-layout="row gutter-none middle margin-top--xxs">
					  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
					  <div
						data-layout="col 11 margin-top--xs padding-left--xs text-left">
						  {
							isNewService && cartItemName !== serviceNameOrig &&
							<React.Fragment>
								{__t('За:')} <Button
							  className={`${buttons.buttonLink} ${buttons.action}`}
							  onClick={() => setShowInputField(true)}
							  value={cartItemName}/>
							</React.Fragment>
						  }
						  {
							  isRenewService ? __t('За: :accountName', {accountName: accountName}) : ''
						  }
					  </div>
				  </div>
				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				  {/*Основен домейн край*/}
				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
				  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}

			  </div>
		  </div>
		  {
			showInputField && isNewService &&
			<SSLDomainName
			  domainName={cartItemName === serviceNameOrig ? '' : cartItemName}
			  setSSLDomainName={setSSLDomainName}
			  isSSLWildCard={isSSLWildCard}
			  serviceId={serviceId}
			  lineId={id}/>
		  }
		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
		  {/*Дъщерни услуги начало*/}
		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
		  {
			  (childServices) ?
				childServices.map((child, i) => {

					let title = child.serviceName;
					if (child.serviceType === 'SSL_INSTALL') {
						title = __t('ние-ще-се-погрижим-изцяло-за-сигурната-връзка-на-f4dad9');
					}

					return (
					  <div key={i} data-layout="row gutter-none middle margin-top--xxs">
						  <div className={styles.removeContainer} data-layout='col 1 margin-top--sm'>
							  {
								child.canDelete === true &&
								<button data-layout={!showAsPage ? 'margin-left--xxs' : ''}
										className={`${buttons.buttonImage} ${styles.removeButton}`}
										onClick={() => removeService(child.id, child.serviceId, child.serviceName)}>
									<img src={removeImg} alt={__t("Remove")}/>
								</button>
							  }
						  </div>
						  <div
							className={styles.childServiceContainer}
							data-layout={`col 11 margin-top--smm padding-left--xs text-left ${showAsPage ? '5@md' : ''}`}>
							  {child.serviceType === 'SSL_INSTALL' ?
								<>
									<div title={title} style={{display: "inline-block"}}>
										{child.serviceName}
									</div>
									<div style={{display: "inline-block", paddingRight: "5px"}}>
										<Tooltip>
											{__t('managed-ssl-е-услуга-при-която-нашите-специалисти1d8bcf')}
										</Tooltip>
									</div>
								</>
								:
								<table>
									<tbody>
									<tr>
										<td>
											<span title={title}>{child.serviceName}</span>
										</td>
									</tr>
									</tbody>
								</table>
							  }
						  </div>

						  <div data-layout={`col 1 ${showAsPage ? 'hide@md' : ''}`}/>
						  <div
							className={styles.childServiceContainerPrice}
							data-layout={`col 11 margin-top--xs padding-left--xs text-left ${showAsPage ? '6@md margin-top--smm' : ''}`}>
							  <table>
								  <tbody>
								  <tr>
									  <td style={{width: '120px'}}>
									  </td>
									  <td className={styles.oldPrice}>
										  {
											  child.priceOrig !== child.priceTopOrig ? child.priceTopOrig : null
										  }
										  {SHVO.showEuroPrices && <>
											  <br/>
											  {
												  child.priceOrig !== child.priceTopOrig ? ConvertToEUR(child.priceTopOrig) : null
											  }
										  </>}
									  </td>
									  <td>

										  <Price
											currency={child.currency}
											value={child.price}
											currencyClass={styles.childCurrency}/>
										  {SHVO.showEuroPrices && <>
											  <br/>
											  <Price
												currency={'EUR'}
												value={ConvertToEUR(child.price)}
												currencyClass={styles.childCurrency}/>
										  </>}
									  </td>
								  </tr>
								  </tbody>
							  </table>
						  </div>
						  {
							  (child.percentOff > 0) ?
								<div data-layout="col 12">
									<div data-layout="row gutter-none middle" className={styles.vpsDiscounts}>
										<div
										  data-layout="col 11 offset-1 margin-top--xs padding-left--xs text-left margin-right--20"
										  className={helpers.orderServiceDiscount}>
											{__t('-:percentOff% отстъпка', {percentOff: child.percentOff})}
										</div>
									</div>
								</div>
								: ''
						  }
					  </div>
					)
				})

				: undefined
		  }

		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
		  {/*Дъщерни услуги край*/}
		  {/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}

	  </section>
	);

};

const SSLDomainName = ({domainName, lineId, setSSLDomainName, isSSLWildCard, serviceId}) => {

	const [value, setValue] = useState(domainName);
	const [tooltip, setTooltip] = useState(serviceId);
	useEffect(() => {
		if (domainName === '') {
			if (isSSLWildCard) {
				setValue('*.')
			} else {
				setValue('www.')
			}
		}

		if (serviceId === 'ssl_gt_quick_02prem') {
			setTooltip(<Tooltip wider={true}>
				{__t('въведете-име-на-домейн-или-поддомейн-за-който-ще-c6bc1d')}
			</Tooltip>);
		} else if (serviceId === 'ssl_goget_01') {
			setTooltip(<Tooltip wider={true}>
				{__t('въведете-име-на-домейн-за-който-ще-се-инсталира-e308d53')}
				<br/><br/>
				<ul className={styles.sslList}>
					<li>{__t('валиден е за mysupersite.com-ezwf232fww')}</li>
					<li>{__t('и за www.mysupersite.com.-ezwf232fww')}</li>
				</ul>
				<br/>
				{__t('това-важи-и-за-поддомейни-от-първо-ниво-пример-eze8d8bc')}
				<br/><br/>
				<ul className={styles.sslList}>
					<li>{__t('валиден е за subdomain.mysupersite.com-ezwf232fww')}</li>
					<li>{__t('и за www.subdomain.mysupersite.com.ezsf242fww')}</li>
				</ul>
				<br/>
				{__t('Сертификатът, който е издаден за домейн-ezsf246fsz')}
			</Tooltip>);
		} else {
			setTooltip(<Tooltip wider={true}>
				{__t('въведете-име-на-домейн-за-който-ще-се-инсталира-сdb0ebb')}
				<br/>
				{__t('Ето няколко примера:')}
				<br/><br/>
				<ul className={styles.sslList}>
					<li>{__t('с www: (www.ime-na-domain.com)')}</li>
					<li>{__t('без www: (ime-na-domain.com)')}</li>
					<li>{__t('за поддомейн: (subdomain.ime-na-domain.com)')}</li>
				</ul>
				<br/><br/>
				{__t('сертификат-който-е-издаден-за-домейн-не-важи-за-п11d682')}
			</Tooltip>);
		}
	}, []);


	return (
	  <div data-layout="row gutter-none middle margin-top--xxs"
		   className={`${styles.sslDomainNameContainer} ${domainName === '' ? styles.withoutDomainName : ''}`}>
		  <div className={styles.removeContainer} data-layout='col 1 margin-top--sm'>

		  </div>
		  <div
			className={styles.childServiceContainer}
			data-layout={`col 11 margin-top--smm padding-left--xs text-left`}>
			  <p>{__t('Укажете домейн за сертификата:')}</p>
			  <div className={styles.sslInputContainer}>
				  <div className={styles.tooltipAndSSLInput}>
					  {tooltip}
					  <TextBox
						value={value}
						name={'ssl_domain_name'}
						placeholder={'mydomain.com'}
						onChange={({target}) => setValue(target.value)}/>
				  </div>
				  <div className={styles.buttonContainer}>
					  <Button onClick={() => setSSLDomainName(lineId, value)} value={__t('Запази')}/>
				  </div>
			  </div>
		  </div>
	  </div>
	)
}


CartLineSSL.propTypes = {
	data: PropTypes.shape({
		id: PropTypes.string.isRequired,
		serviceId: PropTypes.string.isRequired,
		serviceName: PropTypes.string.isRequired,
		serviceTypeName: PropTypes.string.isRequired,
		servicePriceId: PropTypes.string.isRequired,
		isNewService: PropTypes.bool,
		isRenewService: PropTypes.bool,
		isFree: PropTypes.bool,
		canDelete: PropTypes.bool,
		term: PropTypes.string,
		oldPrice: PropTypes.string,
		price: PropTypes.string,
		currency: PropTypes.string,
		priceOrig: PropTypes.string,
		mainDomainData: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({
			domainTLD: PropTypes.string,
			isCyrillic: PropTypes.bool,
			lineId: PropTypes.string,
			name: PropTypes.string,
		})]),
		priceData: PropTypes.arrayOf(
		  PropTypes.shape({
			  currency: PropTypes.string,
			  oldPrice: PropTypes.string,
			  price: PropTypes.string,
			  priceId: PropTypes.string,
			  term: PropTypes.string,
		  })
		),
		discountPriceList: PropTypes.number,
		discountPromo: PropTypes.number,
		discountTerm: PropTypes.number,
	}),
	taxonomy: PropTypes.object,
	removeService: PropTypes.func.isRequired,
	changeServiceTerm: PropTypes.func.isRequired,
	showAsPage: PropTypes.bool
};

export default CartLineSSL;